import { narrowToWideCompositions } from '../compositions';
import { sanatizeInteger } from '../helpers/util';
import { useWidestComposition } from './useWidestComposition';
export function usePaginationItems(inputCurrent, inputTotal, maxWidth) {
    var total = sanatizeInteger(inputTotal);
    var current = total < 1 ? null : Math.max(1, Math.min(sanatizeInteger(inputCurrent), total));
    var narrowToWideCompositionsProvider = function () {
        return narrowToWideCompositions(current, total);
    };
    return useWidestComposition(narrowToWideCompositionsProvider, maxWidth);
}
